<template>
	<SOSlotBase
		:bg-white="true"
		:container-name="pageSetting.containerName"
		:loading="pageSetting.loading.list"
	>
		<template v-slot:title-bar>
			<SOTitleBar
				:page-title="pageSetting.pageTitle"
				:type="'back'"
				@back="back"
			/>
		</template>

		<template v-slot:loading-page>
			<SOLoadingPage/>
		</template>

		<template v-slot:empty-state>
			<div v-if="riwayatTransfer.data !== undefined">
				<SOEmptyState
					v-if="riwayatTransfer.data.count === 0 && !isSearch"
					:message="'Riwayat bank transfer tidak ditemukan'"
				/>
			</div>
		</template>

		<template v-slot:content>
			<div v-if="riwayatTransfer.data !== undefined">
				<SOExportProgressMinimized
					v-if="pageSetting.minimizedExport"
					:processed-data="exportProgress.processed"
					:total-data="exportProgress.total"
					:context="'riwayat transfer'"
					:tracker-actions="'rekeningBankModule/exportTrack'"
					@on-success="checkExport"
					@on-error="() => { pageSetting.minimizedExport = false }"
				/>
				<SOExportMultipleFile
					v-if="pageSetting.multipleExport && !pageSetting.minimizedExport"
					:export-data="exportData"
					:export-data-length="exportDataLength"
					:delete-cluster-actions="'rekeningBankModule/exportDeleteCluster'"
					:delete-master-actions="'rekeningBankModule/exportDeleteMaster'"
					@downloaded="(index) => { exportData[index].downloaded = true }"
					@done="() => { pageSetting.multipleExport = false; exportData = [] }"
				/>

				<div class="p-x-20 p-y-8 bg-white" v-if="riwayatTransfer.data !== undefined">
					<div class="f-regular f-13">
						<span class="f-c-black">Rekening: </span>
						<span class="f-c-midgrey">{{ rekeningBankDetail.nama }} - {{
								rekeningBankDetail.nomor_rekening
							}}</span>
					</div>
				</div>
				<div class="p-x-20 p-t-12 bg-gray" v-if="!pageSetting.loading.list">
					<SOHeaderList
						:title="`${riwayatTransfer.data.count}x Transfer`"
						:show-filter="true"
						@filter="() => { pageSetting.showFilter = true }"
					/>
				</div>
				<div class="m-l-12 m-r-12 riwayat-transfer-separator"
				     v-for="data in riwayatTransfer.data.data_array"
				     :key="data.idjurnal"
				     @click="routeDetail(data, $event)"
				>
					<SOSlotCard :cardType="'none'">
						<template v-slot:card_head>
							<div class="m-d-4 card-fix-padding" v-if="data.hapus === 1">
							<span class="f-regular f-12 f-c-red nota-terhapus">
								Nota terhapus • Refund kas laci
							</span>
							</div>

							<div class="d-flex-between-center p-d-4 p-t-8 card-fix-padding">
								<div class="f-regular f-16 text-capitalize"
								     :class="{'f-c-black': data.hapus === 0, 'f-c-midgrey': data.hapus === 1}">
									{{ data.state }}
									<img src="@/assets/img/chevron-right 1.svg" alt=""
									     v-if="itemToAction.includes(data.ref_type)">
								</div>
								<div
									class="f-regular f-16"
									:class="{'f-c-green': data.nominal > 0, 'f-c-midgrey': false, 'f-c-red': data.nominal < 0}"
								>
									<span v-if="data.nominal > 0">
										+ Rp. {{ formatRupiah((data.nominal).toString()) }}
									</span>
									<span v-if="data.nominal < 0">
										- Rp. {{ formatRupiah((data.nominal * -1).toString()) }}
									</span>
								</div>
							</div>
						</template>
						<template v-slot:card_body>
							<div class="card-fix-padding">
								<div class="f-regular f-13 f-c-midgrey" v-html="getTextByState(data)"></div>

								<div class="f-regular f-13 f-c-midgrey">
									{{ $moment(data.waktu).format("DD MMM YYYY HH:mm") }} oleh
									{{ data.nama_pembuat }}
								</div>
							</div>
						</template>
					</SOSlotCard>
				</div>

				<SOLoadMoreLoading
					v-if="riwayatTransfer.data.count > 0"
					:id="pageSetting.idLoadMore"
					:loading="pageSetting.loading.loadMore"
				/>
				<SOFABExport
					@export="() => { pageSetting.modal.export = true }"
				/>
			</div>
		</template>

		<template v-slot:filter>
			<SOFilter
				v-if="pageSetting.showFilter"
				:filter-riwayat-transfer-bank="true"
				@back="() => { pageSetting.showFilter = false }"
				@do-filter="doFilter"
				@reset-filter="resetFilter"
			/>
		</template>

		<template v-slot:modal>
			<SOModalExport
				v-if="pageSetting.modal.export"
				:is-running="pageSetting.minimizedExport"
				:context="''"
				:total-data="`${riwayatTransfer.data.count} Transfer`"
				:export-data-exist="exportData.length > 0 ? exportData.filter(v => v.downloaded === false).length : 0"
				@close="() => { pageSetting.modal.export = false }"
				@do-export="doExport"
			/>
		</template>

		<template v-slot:export-import>
			<SOExportProgress
				v-if="pageSetting.loading.export"
				:context="'riwayat transfer'"
				:tracker-actions="'rekeningBankModule/exportTrack'"
				@on-success="checkExport"
				@on-error="() => { pageSetting.loading.export = false }"
				@minimized-export="minimizedExport"
			/>
		</template>
	</SOSlotBase>
</template>

<script>
import {mapGetters} from "vuex";
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOExportProgressMinimized from "@/so-components/global/ui/SOExportProgressMinimized";
import SOExportMultipleFile from "@/so-components/global/ui/SOExportMultipleFile";
import SOEmptyState from "@/so-components/global/ui/SOEmptyState";
import SOHeaderList from "@/so-components/global/ui/SOHeaderList";
import SOSlotCard from "@/so-components/global/slot/SOSlotCard";
import SOLoadMoreLoading from "@/so-components/global/ui/SOLoadMoreLoading";
import SOFABExport from "@/so-components/global/ui/SOFABExport";
import SOFilter from "@/so-components/global/filter/base/SOFilter";
import SOModalExport from "@/so-components/global/modal/SOModalExport";
import SOExportProgress from "@/so-components/global/ui/SOExportProgress";

export default {
	name: "RekeningBankRiwayatTransfer",
	components: {
		SOSlotBase,
		SOLoadingPage,
		SOTitleBar,
		SOExportProgressMinimized,
		SOExportMultipleFile,
		SOEmptyState,
		SOHeaderList,
		SOSlotCard,
		SOLoadMoreLoading,
		SOFABExport,
		SOFilter,
		SOModalExport,
		SOExportProgress,
	},
	computed: {
		...mapGetters("rekeningBankModule", {
			rekeningBankDetail: "getRekeningBankDetail",

			riwayatTransfer: "getRiwayatTransfer",
			pagination: "getPaginationRiwayatTransfer",
			searchKey: "getSearchRiwayatTransfer",
			isSearch: "getIsSearchRiwayatTransfer",
			scrollPosition: "getScrollPositionRiwayatTransfer",
		}),
		...mapGetters("filterGlobalModule", {
			filter: "getFilter",
			filterItem: "getFilterItem",
		}),
	},
	async mounted() {
		await this.scroll()
	},
	data() {
		return {
			itemToAction: [
				"transaksi",
				"masal_transaksi",
				"pembelian_emoney",
				"pembelian_deposit",
				"snap_transaksi",
				"settlement_edc",
				"keuangan_transfer",
				"keuangan_modal",
				"keuangan_entry",
				"keuangan_prive",
				// "keuangan_biaya",
			],
			pageSetting: {
				containerName: "list-riwayat-transfer",
				idLoadMore: "loading-list-riwayat-transfer",
				pageTitle: "Riwayat Transfer",
				showFilter: false,
				loading: {
					list: true,
					loadMore: false,
					page: false,
					export: false,
				},
				modal: {
					export: false
				},
				error: {
					list: false,
				},
				minimizedExport: false,
				multipleExport: false,
			},
			exportProgress: {
				processed: 0,
				total: 0,
			},
			exportData: [],
			exportDataLength: 0,
		}
	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			let query = vm.$route.query
			vm.id = vm.$route.params.id
			if (from.path.split("/")[1] !== "rekening-bank") {
				if (vm.riwayatTransfer.data !== undefined) {
					vm.pageSetting.loading.list = false
					vm.setScrollPosition()
					return;
				}
				vm.initRiwayatTransfer(query)
			} else {
				if (vm.riwayatTransfer.data === undefined) {
					vm.initRiwayatTransfer(query)
					return
				}
				vm.setScrollPosition()
			}
		})
	},
	methods: {
		back() {
			this.$router.back()
		},
		async getDetail() {
			this.pageSetting.loading.list = true
			const res = await this.$store.dispatch("rekeningBankModule/fetchRekeningBankDetail", this.id)
			this.pageSetting.loading.list = false
			if (!res.success) {
				this.$toast.error(res.err)
				this.back()
			}
		},

		async initRiwayatTransfer(query) {
			await this.getDetail()
			await this.flushData()

			await this.setDefaultFilter(query)
			await this.listRiwayatTransfer()
		},
		async setDefaultFilter(query) {
			await this.$store.commit("filterGlobalModule/resetFilterItem")

			if (Object.keys(query).length > 0) {
				let filterItem = this.filterItem
				if (query.tanggal_awal) filterItem.periode.startDate = query.tanggal_awal
				if (query.tanggal_akhir) filterItem.periode.endDate = query.tanggal_akhir
				if (query.pembayaran_transaksi) if (query.pembayaran_transaksi.toString() === "1") filterItem.uangMasukRiwayatTransfer = [...filterItem.uangMasukRiwayatTransfer, "pembayaran_transaksi"]
				if (query.transfer_masuk) if (query.transfer_masuk.toString() === "1") filterItem.uangMasukRiwayatTransfer = [...filterItem.uangMasukRiwayatTransfer, "transfer_masuk"]
				if (query.settlement_edc) if (query.settlement_edc.toString() === "1") filterItem.uangMasukRiwayatTransfer = [...filterItem.uangMasukRiwayatTransfer, "settlement_edc"]
				if (query.entry_manual_masuk) if (query.entry_manual_masuk.toString() === "1") filterItem.uangMasukRiwayatTransfer = [...filterItem.uangMasukRiwayatTransfer, "entry_manual_masuk"]
				if (query.refund_transaksi) if (query.refund_transaksi.toString() === "1") filterItem.uangKeluarRiwayatTransfer = [...filterItem.uangKeluarRiwayatTransfer, "refund_transaksi"]
				if (query.transfer_keluar) if (query.transfer_keluar.toString() === "1") filterItem.uangKeluarRiwayatTransfer = [...filterItem.uangKeluarRiwayatTransfer, "transfer_keluar"]
				if (query.pengeluaran_biaya) if (query.pengeluaran_biaya.toString() === "1") filterItem.uangKeluarRiwayatTransfer = [...filterItem.uangKeluarRiwayatTransfer, "pengeluaran_biaya"]
				if (query.entry_manual_keluar) if (query.entry_manual_keluar.toString() === "1") filterItem.uangKeluarRiwayatTransfer = [...filterItem.uangKeluarRiwayatTransfer, "entry_manual_keluar"]

				await this.$store.commit("filterGlobalModule/setFilterItem", filterItem)

				if (query.key) {
					await this.$store.commit("rekeningBankModule/setSearchRiwayatTransfer", query.key)
					await this.$store.commit("rekeningBankModule/setIsSearchRiwayatTransfer", true)
				}

				let temp = this.filter
				temp.sortBy = query.sort_by
				temp.orderBy = query.order_by
				await this.$store.commit("filterGlobalModule/setFilter", temp)
			} else {
				await this.resetFilter()
			}

			await this.$store.commit("rekeningBankModule/resetPaginationRiwayatTransfer")
		},
		async listRiwayatTransfer() {
			if (!this.pageSetting.loading.list) {
				this.pageSetting.loading.loadMore = true
			}
			// if (this.riwayatTransfer.data !== undefined && this.riwayatTransfer.data.lenght === 0) {
			// 	this.pageSetting.search.waiting = true
			// }
			const res = await this.$store.dispatch("rekeningBankModule/fetchRiwayatTransferList", this.rekeningBankDetail.idakun_keuangan)
			this.pageSetting.loading.list = false
			this.pageSetting.loading.loadMore = false
			// this.pageSetting.search.waiting = false
			this.$store.commit("helper/setScrollCalled", false)
			if (res.success) {
				this.pageSetting.error.list = false
				await this.$store.commit("rekeningBankModule/setNextPaginationRiwayatTransfer", {data: this.riwayatTransfer.data})
			} else {
				this.pageSetting.error.list = true
				setTimeout(() => {
					this.pageSetting.error.list = false
				}, 10000)
				this.$toast.error(res.err)
			}
		},

		// filter
		async doFilter() {
			this.pageSetting.showFilter = false
			// if (this.isSearch && this.searchKey.key.length < 2) {
			// 	return
			// }
			this.pageSetting.loading.list = true
			// this.pageSetting.search.waiting = true
			await this.$store.commit("rekeningBankModule/resetPaginationRiwayatTransfer")
			await this.$store.commit("rekeningBankModule/resetRiwayatTransfer")
			await this.listRiwayatTransfer()
		},
		async resetFilter() {
			let temp = this.filter
			await this.$store.commit("filterGlobalModule/resetFilterItem")
			await this.$store.commit("filterGlobalModule/setFilter", temp)
		},

		getTextByState(data) {
			let namaOutletWorkshop = data.nama_outlet_workshop ? data.nama_outlet_workshop : ""
			let text = ""
			switch (data.ref_type) {
				case "transaksi":
					text = "Transaksi Reguler<br>" + data.ref_id + "  •  " + namaOutletWorkshop
					break
				case "masal_transaksi":
					text = "Transaksi Reguler" + data.ref_id + "  •  " + namaOutletWorkshop
					break
				case "pembelian_emoney":
					text = "Top Up E-Payment<br>" + data.ref_id + "  •  " + namaOutletWorkshop
					break
				case "pembelian_deposit":
					text = "Top Up Deposit<br>" + data.ref_id + "  •  " + namaOutletWorkshop
					break
				case "snap_transaksi":
					text = "Transaksi Snapclean<br>" + data.ref_id + "  •  " + namaOutletWorkshop
					break
				case "paylink_topup_customers":
					text = "Top Up Paylink Konsumen<br>" + data.ref_id + "  •  " + namaOutletWorkshop
					break
				case "settlement_edc":
					text = namaOutletWorkshop
					break
				case "keuangan_transfer":
					text = "Kas bank / setoran"
					break
				case "potongan":
					text = "Bayar Potongan" + "  •  " + namaOutletWorkshop
					break
				case "kasbon":
					text = "Bayar Kasbon" + "  •  " + namaOutletWorkshop
					break
				case "keuangan_modal":
					text = "Setoran Modal"
					break
				case "keuangan_entry":
					text = ""
					break

				case "keuangan_prive":
					text = "Pengambilan Prive"
					break
				case "keuangan_deviden":
					text = "Pengambilan Deviden"
					break
				case "keuangan_biaya":
					text = "Pengeluaran" + "  •  " + namaOutletWorkshop
					break
				case "pembayaran_gaji":
					text = "Pembayaran Gaji" + "  •  " + namaOutletWorkshop
					break
				case "paylink_balance_topups":
					text = "Top Up Paylink Owner"
					break

				default:
					break
			}
			return text
		},

		routeDetail(data, event) {
			this.$store.commit("rekeningBankModule/setScrollPositionRiwayatTransfer", event.pageY)
			switch (data.ref_type) {
				case "transaksi":
					this.$router.push("/transaksi/reguler/detail/" + data.ref_id + "?noAction=true")
					break
				case "masal_transaksi":
					this.$router.push("/transaksi/reguler/detail/" + data.ref_id + "?noAction=true")
					break
				case "pembelian_emoney":
					this.$router.push("/transaksi/epayment/topup/" + data.ref_id)
					break
				case "pembelian_deposit":
					this.$router.push("/transaksi/deposit/topup/" + data.ref_id)
					break
				case "snap_transaksi":
					this.$router.push("/transaksi/snapclean/detail/" + data.ref_id)
					break
				case "settlement_edc":
					this.$router.push({name: "mesin.edc.detail_setoran_global", params: {id_settlement: data.ref_id}})
					break
				case "keuangan_transfer":
					this.$router.push({
						name: "RekeningBank.DetailSetoran",
						params: {ref_type: data.ref_type, ref_id: data.ref_id}
					})
					break
				case "keuangan_modal":
					this.$router.push({
						name: "RekeningBank.DetailSetoran",
						params: {ref_type: data.ref_type, ref_id: data.ref_id}
					})
					break
				case "keuangan_entry":
					this.$router.push({
						name: "RekeningBank.DetailSetoran",
						params: {ref_type: data.ref_type, ref_id: data.ref_id}
					})
					break
				case "keuangan_prive":
					this.$router.push({
						name: "RekeningBank.DetailSetoran",
						params: {ref_type: data.ref_type, ref_id: data.ref_id}
					})
					break
				// case "keuangan_biaya":
				// 	break
				default:
					break
			}
		},

		// export
		async doExport() {
			this.pageSetting.loading.export = true
			this.pageSetting.modal.export = false
			const res = await this.$store.dispatch("rekeningBankModule/export", this.rekeningBankDetail.idakun_keuangan)
			if (!res.success) {
				this.pageSetting.loading.export = false
				this.$toast.error(res.err)
			}
		},
		async checkExport() {
			this.pageSetting.loading.export = false
			this.pageSetting.minimizedExport = false
			this.pageSetting.multipleExport = false
			const res = await this.$store.dispatch("rekeningBankModule/exportTrack")
			if (!res.success) {
				return
			}
			this.exportDataLength = res.data.length
			if (res.data.info_data_export.length > 0) {
				if (res.data.status === 1) {
					this.pageSetting.multipleExport = true
					this.exportData = res.data.info_data_export
					this.exportData.forEach(v => {
						v["downloaded"] = false
					})
				} else {
					this.pageSetting.minimizedExport = true
				}
			}
		},
		minimizedExport() {
			this.pageSetting.loading.export = false
			this.pageSetting.minimizedExport = true
			this.exportProgress.processed = Number(data.processed)
			this.exportProgress.total = Number(data.total)
		},

		// scroll
		scroll() {
			window.onscroll = async () => {
				if (this.pageSetting.error.list) {
					return
				}
				let payload = {
					idLoadMore: this.pageSetting.idLoadMore,
					container: this.pageSetting.containerName,
					pagination: this.pagination,
					callback: this.listRiwayatTransfer,
				}
				await this.$store.dispatch("helper/scroll", payload)
			}
		},
		setScrollPosition() {
			this.pageSetting.loading.list = false
			setTimeout(() => {
				window.scrollTo(0, this.scrollPosition)
			}, 5)
		},

		async flushData() {
			await this.$store.commit("rekeningBankModule/resetRiwayatTransfer")
			await this.$store.commit("rekeningBankModule/resetPaginationRiwayatTransfer")
			await this.$store.commit("filterGlobalModule/resetFilter")
			await this.$store.commit("rekeningBankModule/resetSearchRiwayatTransfer")
			await this.$store.commit("rekeningBankModule/setIsSearchRiwayatTransfer", false)
		}
	}
}
</script>

<style scoped>
.nota-terhapus {
	padding: 2px 4px;
	background-color: #FFF1F1;
	border-radius: 4px;
}

.riwayat-transfer-separator {
	border-bottom: 1px solid #F4F4F4;
}

.card-fix-padding {
	margin: 0 -10px;
}
</style>